import { StopLight, PlayLight, ZoomOutCustom, CursorTooltipLight } from '@repo/go-icons';
import { ActionsBar, Tooltip } from '@repo/go-ui';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import type { ImageBroadcastingWidgetState } from '../../model/ImageBroadcastingWidgetState';

import { BroadcastsSelectPanel } from './BroadcastsSelectPanel';
import { VisibilityPanel } from './VisibilityPanel';
import { WellboreSelectPanel } from './WellboreSelectPanel';

type BroadcastingActionsBarProps = {
  widgetState: ImageBroadcastingWidgetState;
  resetScale: VoidFunction;
};

export const BroadcastingActionsBar = observer(function BroadcastingActionsBar({
  widgetState,
  resetScale,
}: BroadcastingActionsBarProps) {
  const { t } = useTranslation('imageBroadcast');

  return (
    <ActionsBar>
      <ActionsBar.TopBar>
        <ActionsBar.Item
          active={widgetState.isTooltipVisible}
          onClick={() => widgetState.setTooltipVisible(!widgetState.isTooltipVisible)}
        >
          <CursorTooltipLight />
        </ActionsBar.Item>
        <Tooltip placement="left" title={widgetState.isPlaying ? t('pause') : t('play')}>
          <ActionsBar.Item onClick={() => widgetState.setPlayingState(!widgetState.isPlaying)}>
            {widgetState.isPlaying ? <StopLight /> : <PlayLight />}
          </ActionsBar.Item>
        </Tooltip>
        <Tooltip placement="left" title={t('resetZoom')}>
          <ActionsBar.Item onClick={() => resetScale()}>
            <ZoomOutCustom />
          </ActionsBar.Item>
        </Tooltip>
        <ActionsBar.Divider />
        <WellboreSelectPanel widgetState={widgetState} />
        <BroadcastsSelectPanel widgetState={widgetState} />
        <VisibilityPanel widgetState={widgetState} />
      </ActionsBar.TopBar>
    </ActionsBar>
  );
});
